import React from 'react';
import appIcon from '../assets/logo-png.png';

const Header = () => {
  return (
    <header className="w-full text-white flex items-center shadow-sm" style={{ background: '#8034c4', height: '3rem', minHeight: '3rem', maxHeight: '3rem', padding: 0 }}>
      <img
        src={appIcon}
        aria-hidden="true"
        alt="AVVACare Logo"
        className="object-contain"
        style={{ height: '2.8rem', width: '3.7rem', minWidth: 0, minHeight: 0, maxHeight: '2.95rem', maxWidth: '3.7rem', display: 'block', marginLeft: '10px', marginRight: '14px', verticalAlign: 'top', paddingTop: '0.05rem', paddingBottom: '0.05rem' }}
      />
      <h1
        className="text-[1.1rem] font-bold tracking-tight ml-2"
        aria-label="AVVACare Copilot"
        style={{ lineHeight: 1, margin: 0, fontFamily: 'Arial, Helvetica, sans-serif', letterSpacing: '0.03em' }}
      >
        AVVACare Copilot
      </h1>
    </header>
  );
};

export default Header;